import type { Logger } from '@vp/ubik-logging'
import type { NewUdsDocument, PostDocumentResponse } from '../types/UdsDocument'

const baseUrl = 'https://storage.documents.cimpress.io'

export const postDocument = async (document: NewUdsDocument, authorizationHeader: string, logger: Logger): Promise<PostDocumentResponse> => {
  try {
    const url = `${baseUrl}/v3/documents`
    const headers = { Authorization: authorizationHeader, 'Content-Type': 'application/json' }
    const request = new Request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(document),
    })

    const response = await fetch(request)

    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status: ${response.statusText}`)
    }

    const data = (await response.json()) as PostDocumentResponse
    return data
  } catch (error) {
    logger.error('Unable to save document to UDS', error as Error)
    throw new Error('Unable to save document to UDS')
  }
}
